---
nb:
  api_key: API Nøkkel
  api_keys: API Nøkler
  api_keys_company_access_limit: Viser de %{count} første selskapene. Bruk søk for å finne andre.
  api_keys_confirm_rotate: Rotasjon av token vil ugyldiggjøre eksisterende nøkkel. Vil du fortsette?
  api_keys_toast:
    copied: Token kopiert til utklippstavlen
    create_failed: Kunne ikke opprette API-nøkkel
    created: API-nøkkel opprettet
    delete_failed: Kunne ikke slette API-nøkkel
    deleted: API-nøkkel slettet
    export_started: Eksport startet - vi sender e-post når den er klar
    rotate_failed: Kunne ikke rotere API-nøkkel
    rotated: API-nøkkel token rotert
    update_failed: Kunne ikke oppdatere API-nøkkel
    updated: API-nøkkel oppdatert
  api_keys_token_too_short: Token må være minst {count} tegn langt
  company_access_hint: Velg bedriftene som API-brukeren skal ha tilgang til
  current_access: Gjeldende Tilgang
  expensive_req: lengste forespørsler de siste 7 dager
  recent_request: siste forespørsler
